<template>
  <div class="wrap" v-show="loaded">
    <p class="description">
      Compare how you would have performed against each team in the league, and not just your matchup. Take note of how many teams you would have edged out.
      <br/>
      <span class="warning">Note: This data will refresh once a day for the current week</span>
    </p>
    <div class="settings">
      <div v-show="leagueName" class="top-dropdown">
        <h3 class="nav-panel-header">
          <span>Week:</span>
          <!-- <span v-else>Select week</span> -->
        </h3>
        <form @submit.prevent>
          <select v-model="selectedWeek" @change="settingsVisible = false">
            <option :value="-1" disabled>Select</option>
            <option :value="i" v-for="(week, i) in weeks" v-bind:key="i">{{weeks[i].week}}</option>
          </select>
        </form>
      </div>
    </div>
    <div class="setting">
      <label for="checkBoxRank">
        <p>Show team ranks per category</p>
        <input type="checkbox" id="checkBoxRank" v-model="showRank"/>
      </label>
    </div>
    <div class="table-wrap">
      <div class="fl-table" v-if="weeks[selectedWeek]">
        <div class="fl-row header-row">
          <div class="fl-row-inner">
            <table-cell>
              <h3 class="h6">Team</h3>
            </table-cell>
            <table-cell v-for="(category, i) in weeks[selectedWeek].columns" v-bind:key="i" class="fl-cell">
              <h3 class="h6">{{category.display_name}}</h3>
            </table-cell>
          </div>
        </div>
        <div class="table-content">
          <div
            v-for="(row, i) in weeks[selectedWeek].rows"
            v-bind:key="i"
            class="fl-row"
            :class="{
              'your-row': row.team.is_owned_by_current_login,
              'matchup-row': row.is_matchup
            }">
            <div class="fl-row-inner">
              <table-cell>
                <p>
                  {{row.team.name}}
                </p>
              </table-cell>
              <table-cell
                v-for="(score, j) in row.scores"
                v-bind:key="j"
                class="fl-cell"
                :class="{
                  'victory': score.lost_matchup === false,
                  'defeat': score.lost_matchup === true,
                  'highlight': j === row.scores.length -1
                }"
                :value="score.strValue? score.strValue : score.value"
                :rank="score.rank"
                :showRank="showRank"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import weeks from '@/sample-data/get-weeks'
import tableCell from '@/components/cell/cell.vue'
export default {
  name: "weeks",
  data () {
    return {
      selectedWeek: -1,
      settingsVisible: false,
      leagueData: [],
      weeks: [],
      showRank: false,
    }
  },
  components: {
    'table-cell': tableCell
  },
  props: ['leagues', 'selectedLeague', 'loaded', 'leagueName'],
  computed: {},
  created: function () {
    if(this.selectedLeague.yahoo_object.league_key) {
      this.selectLeague()
    }
  },
  methods: {
    selectLeague: async function () {
      try {
        this.$store.dispatch('isLoading', true)
        this.weeks = await this.$store.state.apiService.getWeeks(this.selectedLeague.yahoo_object.league_key)
        this.selectedWeek = this.weeks.length - 1
      } catch (e) {
        if (e.response && e.response.status && e.response.status === 403) {
          this.$store.dispatch('login', true)
        }
      } finally {
        this.$store.dispatch('isLoading', false)
      }
    },
    ordinal: function (num) {
      let ending
      switch (num) {
        case 1:
          ending = "st"
          break;
        case 2:
          ending = "nd"
          break;
        case 3:
          ending = "rd"
          break;
        default:
          ending = "th"
          break;
      }
      return ending
    }
  },
  watch: {
    leagueName: function (val) {
      if (val) this.selectLeague()
    }
  }
}
</script>

<style src="./weeks.styl" lang="stylus" scoped></style>
